import radiologyliveLogo from '@/assets/icons/radiologylive-logo.svg';
import livespeakLogo from '@/assets/icons/livespeak-logo.svg';
import liveinsightLogo from '@/assets/icons/liveinsight-logo.svg';

interface ProductIconProps {
  className?: string;
  size?: number;
}

export function RadiologyLiveIcon({ className, size = 32 }: ProductIconProps) {
  return (
    <img
      src={radiologyliveLogo}
      alt="RadiologyLive.ai"
      height={size}
      width={Math.round(size * 1.5)}
      className={className}
    />
  );
}

export function LiveSpeakIcon({ className, size = 32 }: ProductIconProps) {
  return (
    <img
      src={livespeakLogo}
      alt="LiveSpeak"
      width={size}
      height={size}
      className={className}
    />
  );
}

export function LiveInsightIcon({ className, size = 32 }: ProductIconProps) {
  return (
    <img
      src={liveinsightLogo}
      alt="LiveInsight"
      width={size}
      height={size}
      className={className}
    />
  );
}
